<template>
  <section>
    <v-card tile>
      <v-card-title class="admin_secondary white--text">
        <span @click="show=!show" class="clicky">About</span>
        <v-spacer></v-spacer>
        <v-btn dark icon class="draggable">
          <v-icon>fa fa-align-justify</v-icon>
        </v-btn>
        <v-btn icon dark @click="show=!show">
          <v-icon v-if="show">fa-minus</v-icon>
          <v-icon v-else>fa-chevron-down</v-icon>
        </v-btn>
      </v-card-title>
      <v-divider dark></v-divider>
      <v-expand-transition>
        <div v-show="show">
          <v-card-actions class="grey lighten-3">
            <v-switch label="Preview" v-model="preview" color="success"></v-switch>
            <v-spacer></v-spacer>
            <v-btn color="secondary" @click="$emit('duplicate')">Duplicate</v-btn>
            <v-btn color="error" @click="$emit('delete')">Delete</v-btn>
          </v-card-actions>
          <preview v-if="preview" v-model="data"></preview>
          <edit v-else v-model="data" @change="$emit('change')"></edit>
        </div>
      </v-expand-transition>
    </v-card>
  </section>
</template>

<script>
import About from "@/components/page/About";
import edit from "./edit";
import manageMixin from "@/assets/manage-mixin";

export default {
  props: ["value"],
  name: "AdminPageEditAbout",
  components: {
    preview: About,
    edit: edit
  },
  mixins: [manageMixin],
  data() {
    return {
      show: false,
      preview: false
    };
  },
  computed: {
    data() {
      return this.value;
    }
  }
};
</script>

<style>
</style>